import React, { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase'; // your firebase config file
import { useNavigate, useLocation } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const from = location.state?.from?.pathname || '/portal';
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log('login attempted and succeeded')
      // You can redirect the user to a dashboard or home page here
      navigate(from, { replace: true });
    } catch (err) {
      setError('Failed to log in');
      console.error(err);
    }
  };

  return (
    <div className="container ">
      <div className="row">
      
      <h2 style={{ marginBottom: '20px' }}>Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleLogin} className="col-12 col-lg-auto mb-2 mb-lg-auto">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="login-form fa-search"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="login-form fa-search"
          required
        />
        <button type="submit" className="login-btn">Log In</button>
        <div className="forgot-password"><a href="/forgotpw">Forgot Password?</a></div>
      </form>
    </div>
  </div>
  );
}

export default Login;
